import type { ResponsibilityRow } from './taskDetailModels';

function initials(name: string): string {
  return name
    .split(/\s+/)
    .map((w) => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

export function TaskResponsibilityChain({ rows }: { rows: ResponsibilityRow[] }) {
  return (
    <div className="rounded-xl border border-[#e8edf1] bg-white px-3.5 py-3 shadow-[0_1px_2px_rgba(15,23,42,0.04)]">
      <p className="mb-1.5 text-[9.5px] font-bold uppercase tracking-[0.1em] text-slate-400">
        Responsibility chain
      </p>
      <div className="flex flex-col">
        {rows.map((r, i) => (
          <div key={r.roleLabel}>
            {i > 0 ? <div className="ml-3 h-2.5 w-px bg-slate-300" aria-hidden /> : null}
            <div className="flex items-center gap-2.5 py-1">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#E2EFDB] text-[9px] font-bold text-[#076333]">
                {r.name ? initials(r.name) : '—'}
              </span>
              <span className="min-w-0">
                <b className={`block text-[11px] ${r.name ? 'text-slate-900' : 'font-normal italic text-slate-400'}`}>
                  {r.name ?? '— unassigned'}
                </b>
                <span className="text-[9px] font-bold uppercase tracking-[0.06em] text-slate-400">
                  {r.roleLabel}
                </span>
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
